/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { getAuthToken } from '../../utils/auth';
import { validateUserSession } from '../../utils/user/session';

export const useValidateUserSession = () => {
  const queryClient = useQueryClient();
  const { t: tCommon } = useTranslation('common', { keyPrefix: 'common' });

  const authToken = getAuthToken();
  const notificationTitle = tCommon('notifications.error.expired.title');
  const notificationDescription = tCommon('notifications.error.expired.description');

  if (!authToken) {
    queryClient.removeQueries({ queryKey: ['session.token'] });
  }

  const validateSession = useQuery({
    queryKey: ['session.token'],
    queryFn: () => validateUserSession({ notificationTitle, notificationDescription }),
    refetchInterval: 60 * 1000,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: true,
    enabled: !!authToken,
  });

  return validateSession;
};
